import { LinkItemProps } from '../types/linkItemProps';

export const LinkItemsForPublishUser: Array<LinkItemProps> = [
    { name: 'Dashboard', icon: 'table-columns', url: '/dashboard' },
    { name: 'FAM', icon: 'key', url: '/fam/list' },
    { name: 'Trials', icon: 'clock', url: '/trials/list' },
    { name: 'Publish', icon: 'newspaper', url: '/publish/auto-translation' },
];
